import { createAction, props } from '@ngrx/store';
import {
  RolePermission,
  UserRole,
} from '@shared/interfaces/permissions.interface';

export const setRole = createAction(
  '[Role] Set Role',
  props<{ role: UserRole }>(),
);

export const setEntityRole = createAction(
  '[Role] Set Entity Role',
  props<{ entityId: string; role: UserRole }>(),
);

export const setRolePermissions = createAction(
  '[Role] Set Role Permissions',
  props<{ roleId: string; permissions: RolePermission[] }>(),
);

export const setRolePermissionsLoading = createAction(
  '[Role] Set Role Permissions Loading',
  props<{ roleId: string; loading: boolean }>(),
);
